import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NotifyComponent } from "src/app/_components/notify/notify.component";

@Component({
    selector: "dello-app",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet, NotifyComponent],
})
export class AppComponent {
    constructor() {}
}
